import { PDFDocument } from 'pdf-lib';
import { convertWordToPdf } from './wordConverter';

export async function convertToPdf(file: File): Promise<File> {
  try {
    // If already PDF, return as is
    if (file.type === 'application/pdf') {
      return file;
    }

    // If Word document, convert to PDF
    if (file.type.includes('word') || file.name.endsWith('.doc') || file.name.endsWith('.docx')) {
      return await convertWordToPdf(file);
    }

    // If text file, convert to PDF
    if (file.type === 'text/plain') {
      const pdfDoc = await PDFDocument.create();
      const page = pdfDoc.addPage();
      const text = await file.text();
      
      page.drawText(text, {
        x: 50,
        y: page.getHeight() - 50,
        size: 12,
        maxWidth: page.getWidth() - 100
      });

      const pdfBytes = await pdfDoc.save();
      return new File([pdfBytes], file.name.replace(/\.[^/.]+$/, '.pdf'), {
        type: 'application/pdf'
      });
    }

    throw new Error('Formato de arquivo não suportado');
  } catch (error) {
    console.error('Error converting to PDF:', error);
    throw new Error('Erro ao converter arquivo para PDF. Por favor, tente novamente.');
  }
}